export const actions = {
  SHOW_GLOBAL_ERROR_MESSAGE: 'SHOW_GLOBAL_ERROR_MESSAGE',
  HIDE_GLOBAL_ERROR_MESSAGE: 'HIDE_GLOBAL_ERROR_MESSAGE',
  SHOW_UPLOADING_FILE_POP_UP: 'SHOW_UPLOADING_FILE_POP_UP',
  HIDE_UPLOADING_FILE_POP_UP: 'HIDE_UPLOADING_FILE_POP_UP',
  SEND_CONTACT_MAIL: 'SEND_CONTACT_MAIL',
  SEND_CONTACT_MAIL_SUCCESS: 'SEND_CONTACT_MAIL_SUCCESS',
  SEND_CONTACT_MAIL_FAILURE: 'SEND_CONTACT_MAIL_FAILURE',
};
